import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { ReduxStoreData, StoreApplicant } from '@funnels/types';

import { useCustomer } from '../useCustomer';
import { useFormValues } from '../useFormValues';

export function useCustomerStoreApplicant() {
  const customer = useCustomer();
  const applicants = useSelector((currentState: ReduxStoreData) => currentState.applicants.data);

  if (!customer.data.id) {
    return;
  }

  const applicant = applicants.find((applicant) => applicant.customerId === customer.data.id);

  return applicant;
}

export function useCustomerFormApplicant() {
  const customer = useCustomer();
  const [formValues] = useFormValues();

  if (!customer.data.id) {
    return;
  }

  const applicants: StoreApplicant[] = get(formValues, FIELD_PATHS.APPLICANTS(), []);
  const applicant = applicants.find((applicant) => applicant.customerId === customer.data.id);

  return applicant;
}
